import { isValidApiName } from './typeguards';
export const SkuCategoryNameToProductLineMap = {
  MARKETING_PRODUCTS: {
    freeHighlightedProduct: 'marketing-hub-free',
    paidHighlightedProducts: ['marketing-hub-starter', 'marketing-hub-professional', 'marketing-hub-enterprise']
  },
  SALES_PRODUCTS: {
    freeHighlightedProduct: 'sales-hub-free',
    paidHighlightedProducts: ['sales-hub-starter', 'sales-hub-professional', 'sales-hub-enterprise']
  },
  SERVICE_HUB_PRODUCTS: {
    freeHighlightedProduct: 'service-hub-free',
    paidHighlightedProducts: ['service-hub-starter', 'service-hub-professional', 'service-hub-enterprise']
  },
  CMS_HUB_PRODUCTS: {
    freeHighlightedProduct: 'cms-hub-free',
    paidHighlightedProducts: ['cms-hub-starter', 'cms-hub-professional', 'cms-hub-enterprise']
  },
  OPERATIONS_HUB_PRODUCTS: {
    freeHighlightedProduct: 'operations-hub-free',
    paidHighlightedProducts: ['operations-hub-starter', 'operations-hub-professional', 'operations-hub-enterprise']
  }
};
export const getHighlightedProductsForSkuCategory = ({
  skuCategoryName
}) => {
  var _productsMetadata$pai;
  const productsMetadata = SkuCategoryNameToProductLineMap[skuCategoryName];
  const paidHighlightedProducts = productsMetadata === null || productsMetadata === void 0 || (_productsMetadata$pai = productsMetadata.paidHighlightedProducts) === null || _productsMetadata$pai === void 0 ? void 0 : _productsMetadata$pai.filter(isValidApiName);
  const freeHighlightedProduct = productsMetadata !== null && productsMetadata !== void 0 && productsMetadata.freeHighlightedProduct && isValidApiName(productsMetadata === null || productsMetadata === void 0 ? void 0 : productsMetadata.freeHighlightedProduct) ? productsMetadata === null || productsMetadata === void 0 ? void 0 : productsMetadata.freeHighlightedProduct : undefined;
  return {
    paidHighlightedProducts,
    freeHighlightedProduct
  };
};